import React, {PureComponent} from "react";
import {Icon, Button} from "semantic-ui-react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

class EligibilityRequirements extends PureComponent {
  static propTypes = {
    hexColorCodeC: PropTypes.string,
  };

  render() {
    const { hexColorCodeC } = this.props;
    let message = "All applicants must meet the eligibility requirements in order to be considered.";
    if (this.nicknews = process.env.REACT_APP_UNDER_EIGHTEEN == "1") {
      message = "All children on whose behalf an application is submitted must meet the eligibility requirements."
    }

    return (
        <div>
          <p><em><strong
            style={{ color: `#${hexColorCodeC}` }}
        >{ message }</strong></em></p>
          <Link to="/eligibility">
            <Button className="ui huge black right labeled icon button">
              <Icon className="right chevron"></Icon>
              View Eligibility Requirements
            </Button>
          </Link>
        </div>
    );
  }
}

export default EligibilityRequirements;



// WEBPACK FOOTER //
// ./src/components/common/EligibilityRequirements.js